import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap'
// Custom CSS imports
import '../css/site.css';

console.log('The \'site\' bundle has been loaded!');